import { PolyPlusBadge } from "elements/PolyIcon";
import React from "react";
import "./PolyPlus.scss";
import InactivatedImage from "assets/images/Lens_Abstracted.svg";
import InactivatedImage_Dark from "assets/images/Lens_Abstracted_darkmode.svg";
import { useTranslation } from "utilities/i18n";
import { DOCS } from "Constants";
import { useSelector } from "react-redux";
import { THEME_DEFAULT } from "store/userMeta";
import { State } from "store";
import { usePolyPlusEnabled } from "../../utilities/polyPlus";
import { LensTheme } from "../../generated/graphql.schema";
import HelpLink from "elements/HelpLink";

const Images: Record<LensTheme, string> = {
  [LensTheme.Dark]: InactivatedImage_Dark,
  [LensTheme.Light]: InactivatedImage
};

const PolyPlusImage: React.FC = () => {
  const theme = useSelector((state: State) => {
    return state.userMeta?.theme ?? THEME_DEFAULT;
  });
  const image = Images[theme];
  return (
    <img
      src={image}
      alt="Poly Plus Inactivated"
      data-testid="inactivated-image"
      className="text-left"
    />
  );
};

const PolyPlusInactive: React.FC<{
  tenantId: string;
}> = ({ tenantId, children }) => {
  const { polyPlusEnabled } = usePolyPlusEnabled(tenantId);

  if (polyPlusEnabled) {
    return null;
  }

  return <>{children}</>;
};

const PolyPlusLearnMore: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="font-sm font-bold pt-5">
      <HelpLink location={DOCS.POLY_PLUS_FEATURES}>{t("LEARN_MORE")}</HelpLink>
    </div>
  );
};

export const PolyPlusInactiveModal: React.FC<{
  tenantId: string;
}> = ({ tenantId }) => {
  const { t } = useTranslation();

  return (
    <PolyPlusInactive tenantId={tenantId}>
      <div className="polyplus-inactive-modal modal">
        <div className="overlay blocking" />
        <div className="modal-content d-flex p-15">
          <PolyPlusImage />
          <div className="pl-2">
            <div className="pt-5">
              <PolyPlusBadge />
            </div>
            <div className="font-md font-bold pt-5">
              {t("GET_DEEPER_INSIGHTS_WITH_POLY_PLUS")}
            </div>
            <PolyPlusLearnMore />
          </div>
        </div>
      </div>
    </PolyPlusInactive>
  );
};

export const PolyPlusInfoBox: React.FC<{
  tenantId: string;
}> = ({ tenantId }) => {
  const { t } = useTranslation();

  return (
    <PolyPlusInactive tenantId={tenantId}>
      <div className="poly-plus-info-box d-flex flex-column p-1">
        <PolyPlusImage />
        <div className="font-md font-bold pt-5">
          {t("GET_MORE_WITH_POLY_PLUS")}
        </div>
        <PolyPlusLearnMore />
      </div>
    </PolyPlusInactive>
  );
};
